// Saisie et validation du code de fin (Fin.js, Fin2.js) auprès de public/code.php
import { useState, useEffect, useRef } from 'react';

const DUREE_BLOCAGE = 30 * 60 * 1000; // 30 minutes, comme dans code.php

const useValidationCode = (livre) => {
    const [inputValue, setInputValue] = useState('');
    const [showVideo, setShowVideo] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [attemptHistory, setAttemptHistory] = useState([]);
    // Heure de fin du blocage (ms) ; null si le joueur n'est pas bloqué
    const [blockedUntil, setBlockedUntil] = useState(null);
    const [now, setNow] = useState(Date.now());
    const [pending, setPending] = useState(false);
    const pendingRef = useRef(false);

    const isBlocked = blockedUntil !== null && now < blockedUntil;
    const remainingTime = isBlocked ? blockedUntil - now : null;

    // Compte à rebours du blocage ; le minuteur est arrêté si on quitte la page
    useEffect(() => {
        if (blockedUntil === null) return undefined;
        const interval = setInterval(() => {
            const t = Date.now();
            setNow(t);
            if (t >= blockedUntil) {
                setBlockedUntil(null);
                setErrorMessage('');
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [blockedUntil]);

    const addLetter = (letter) => {
        if (!isBlocked) setInputValue((prev) => prev + letter);
    };

    const reset = () => {
        if (!isBlocked) setInputValue('');
    };

    const validate = async () => {
        // Pas de tentative vide ni de double envoi (double clic)
        if (isBlocked || !inputValue || pendingRef.current) return;
        pendingRef.current = true;
        setPending(true);

        const tentative = inputValue;
        const params = new URLSearchParams({ code: btoa(tentative) });
        if (livre === 2) params.set('livre', '2');

        try {
            const response = await fetch(`/code.php?${params}`);
            const result = (await response.text()).trim();

            if (result === 'true') {
                setInputValue('');
                setShowVideo(true);
                setErrorMessage('Code correct ! Bravo !');
            } else if (result === 'false') {
                setInputValue('');
                setAttemptHistory((prev) => [...prev, tentative]);
                setErrorMessage('Mauvaise réponse.');
            } else if (result === 'lock') {
                setInputValue('');
                setAttemptHistory((prev) => [...prev, tentative]);
                setErrorMessage('Troisième mauvaise réponse, Vous êtes bloqué pendant 30 minutes.');
                const t = Date.now();
                setNow(t);
                setBlockedUntil(t + DUREE_BLOCAGE);
            } else {
                setErrorMessage('Erreur de communication avec le serveur.');
            }
        } catch (error) {
            setErrorMessage('Erreur de communication avec le serveur.');
        } finally {
            pendingRef.current = false;
            setPending(false);
        }
    };

    return {
        inputValue, showVideo, errorMessage, attemptHistory,
        isBlocked, remainingTime, pending,
        addLetter, reset, validate,
    };
};

export const formatTime = (ms) => {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export default useValidationCode;
